import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const TRANSACTION_TYPE = "/master/v1/transactionType";

export const getTransactionTypeApi = async (params, options = {}) => await getRequest(TRANSACTION_TYPE, params, options);

export const getTransactionTypeByIdApi = async (id) =>
  await getRequest(`${TRANSACTION_TYPE}/${id}`);

export const addTransactionTypeApi = async (body) =>
  await postRequest(TRANSACTION_TYPE, body);

export const updateTransactionTypeApi = async (body) =>
  await putRequest(`${TRANSACTION_TYPE}/${body?._id}`, body);

export const deleteTransactionTypeByIdApi = async (id) =>
  await deleteRequest(`${TRANSACTION_TYPE}/${id}`);

export const deleteBankAccountApi = async (transactionTypeId, bankIndex) =>
  await deleteRequest(`${TRANSACTION_TYPE}/${transactionTypeId}/bankAccount/${bankIndex}`);
